import { render, staticRenderFns } from "./Nocalculate.vue?vue&type=template&id=76bd64e8&scoped=true"
import script from "./Nocalculate.vue?vue&type=script&lang=js"
export * from "./Nocalculate.vue?vue&type=script&lang=js"
import style0 from "./Nocalculate.vue?vue&type=style&index=0&id=76bd64e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bd64e8",
  null
  
)

export default component.exports